/**
 * Deli salad plates data
 * Represents plated salads with fixed prices
 */

const deliSaladPlates = [
  {
    id: 1,
    name: "Diet Plate",
    description: "6oz. of Tuna or Chicken Salad on bed of lettuce with sliced tomato, American cheese & a slice of new dill pickle.",
    price: "$16.99",
    category: "salad-plates"
  },
  {
    id: 2,
    name: "Western Salad",
    description: "4 ½ oz. grilled chicken breast on a bed of lettuce w/ Swiss cheese, tomato, olives, hard boiled eggs & choice of dressing.",
    price: "$16.99",
    category: "salad-plates"
  },
  {
    id: 3,
    name: "Julienne Salad",
    description: "Sliced turkey breast, lean corned beef & Swiss cheese on a bed of lettuce, with tomato, olives, hard boiled eggs & choice of dressing.",
    price: "Sm: $11.99 Lg: $14.49",
    category: "salad-plates"
  },
  {
    id: 4,
    name: "Greek Salad",
    description: "Lettuce, tomato, beets, chickpeas, red onion, pepperoncini, Greek olives, feta cheese & Greek dressing.",
    price: "Sm: $8.99 Lg: $11.99",
    category: "salad-plates"
  }
];

module.exports = deliSaladPlates;